"use client";

import { useTranslations } from "next-intl";
import type * as React from "react";
import { DaoYearChips } from "./DaoYearChips";
import { DaoYearCountdown } from "./DaoYearCountdown";
import { DaoYearProgressBar } from "./DaoYearProgressBar";

interface Remaining {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}

interface DaoProgressCardProps {
  currentYear: number;
  remaining: Remaining;
  endSec: bigint;
  decayPercent: number;
}

/** Bordered card: title + year chips + current-year countdown + progress bar + explanation. */
export const DaoProgressCard: React.FC<DaoProgressCardProps> = ({
  currentYear,
  remaining,
  endSec,
  decayPercent,
}) => {
  const t = useTranslations("stake");
  const explanation = t("globalStats.decayExplanation", {
    percent: String(decayPercent),
  });

  return (
    <div className="rounded-lg bg-bg-secondary border border-stroke-light p-4 space-y-3">
      <h3 className="text-sm font-bold text-text-primary text-center">
        {t("globalStats.daoProgressTitle")}
      </h3>
      <DaoYearChips currentYear={currentYear} />
      <DaoYearCountdown endSec={endSec} />
      <DaoYearProgressBar remaining={remaining} />
      <p className="text-xs text-text-secondary text-center leading-relaxed">
        {explanation}
      </p>
    </div>
  );
};
